/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { Function } from "app/models/function";

declare var $: any;

@Component({
  selector: 'app-function-executing-dialog',
  templateUrl: './function-executing-dialog.component.html'
})
export class FunctionExecutingDialogComponent {

  mVisible = false;
  mFunctionName = "";
  mExecutionMessage = "Executing function.....";
  mIsExecuting = false;

  isChecked = false;
  returnData: string | boolean | null = null;

  // ✅ Declare returnType outside (class property)
  returnType: string | null = null;

  showDialogStartExecutingFunction(func: Function): void {
    this.returnType = func?.result?.type ?? null;

    // 🔥 RESET UI STATE

    this.returnData = '';
    this.isChecked = false;

    this.mFunctionName = func.name;
    this.mExecutionMessage = "Executing function.....";
    this.mIsExecuting = true;
    this.mVisible = true;
  }

  showFunctionExecutionSuccess(response: any): void {

    if (this.returnType === null || response === null) {
      this.returnData = null;
    }
    else if (this.returnType === 'BOOLEAN') {
      this.returnData = Boolean(response);
    }
    else {
      // EVERYTHING ELSE is treated as STRING
      this.returnData = JSON.stringify(response);
    }

    this.mExecutionMessage = 'Function completed successfully.';
    this.mIsExecuting = false;
  }

  showFunctionExecutionError(error: string): void {
    this.mExecutionMessage = "Function ERROR: " + error;
    this.mIsExecuting = false;
  }

  hide(): void {
    this.mVisible = false;
    //$("#functionExecutingModal").hide();
  }

  copyResult(): void {
    if (this.returnData !== null) {
      navigator.clipboard.writeText(String(this.returnData));
    }
  }
}
